<script>
import { IntervalUnitType } from 'frontend/ui/services/IntervalInputHelperService/enum/interval-unit-type'
import { IntervalInputHelperService } from 'frontend/ui/services/IntervalInputHelperService/IntervalInputHelperService'
import { computed } from 'vue'

export default {
  name: 'ClientCommunicationRuleDeliveryConditions',
  props: {
    clientCommunicationRule: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const intervalInputHelperService = new IntervalInputHelperService()

    const humanizedSendMinutesBeforeStart = computed(() => {
      if ((props.clientCommunicationRule.sendMinutesBeforeStart || 0) === 0) {
        return 'immediately'
      } else {
        return intervalInputHelperService.convertSecondsToIntervalText(
          (props.clientCommunicationRule.sendMinutesBeforeStart || 0) * 60,
          [IntervalUnitType.Hour, IntervalUnitType.Minute],
          true,
        )
      }
    })

    const humanizedResendMinutesAfterUpdate = computed(() => {
      if ((props.clientCommunicationRule.resendMinutesAfterUpdate || 0) === 0) {
        return 'immediately'
      } else {
        return intervalInputHelperService.convertSecondsToIntervalText(
          (props.clientCommunicationRule.resendMinutesAfterUpdate || 0) * 60,
          [IntervalUnitType.Hour, IntervalUnitType.Minute],
          true,
        )
      }
    })

    return {
      intervalInputHelperService,
      humanizedSendMinutesBeforeStart,
      humanizedResendMinutesAfterUpdate,
    }
  },
}
</script>

<template lang="pug">
.text-nowrap {{ humanizedSendMinutesBeforeStart }} before pick-up
.text-nowrap(v-if="clientCommunicationRule.resendOnUpdate") and {{ humanizedResendMinutesAfterUpdate }} after each update
</template>
